<template>
  <div class="packages-module">
    <div class="filter-bar">
      <!--<img src="~@/assets/img/main/filter.svg" alt="" />-->
      <p class="text-right">لیست پکیج‌ها</p>
    </div>

    <div class="slider">
      <img :src="header">
    </div>

    <div class="package-list">

      <router-link class="package-item d-flex flex-row justify-content-between" v-for="value in packkish" :key="value.id" tag="div" :to="{name: 'packages-single',params: { id:value.id,agname:value.agname,name:value.name,image:'https://kishoto.ir/dtr/approid/img/'+value.image,des:value.des,price:value.price}}">
        <div class="d-flex flex-row image-box">
          <img :src="`https://kishoto.ir/dtr/approid/img/${value.image}`">
        </div>
       <div class="d-flex flex-column package-info justify-content-around w-100">
              <h3>{{value.name}}</h3>
              <div class="d-flex flex-row agancy-price flex-row-reverse justify-content-between">
                  <div class="price-value">{{value.price | toPersianCurrency("تومان",0)}}</div>
                  <div class="count-value">{{value.count}} :تعداد</div>
                  <div class="agancy-name">{{value.agname}}</div>
              </div>
      </div>



      </router-link>

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      packkish: null,
      header: null
    };
  },
  created() {
    this.getPackage();
  },
  methods: {
    async getPackage() {
      const response = await this.$ApiServiceLayer.post("get_package_list");
      console.log(response);
      if (response.msg === "ok") {
        this.packkish = response.list;
        this.header = "https://kishoto.ir/dtr/approid/img/"+response.header1;
        console.log(this.packkish);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.packages-module {
  width: 100%;
  min-height: 100vh;
  background-image: url("~@/assets/img/bg/package_back.jpg");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  padding: 10px;
  .filter-bar {
    width: 100%;
    height: 70px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0 20px;
    font-weight: bold;
    font-size: 17px;
    p {
      font-family: "sans";
      color: #fff;
      margin-bottom: 0;
    }
    img {
      width: 30px;
      object-fit: contain;
      height: 30px;
    }
  }
  .slider {
    width: 100%;
    height: 200px;
    //background-color: red;
    border-radius: 10px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    img{
      width: 100%;
      border-radius: 21px;
    }
  }

  .package-list {
    width: 100%;

    .package-item {
      height: auto;
      padding: 10px;
      border-radius: 18px;
      background-color: rgba(0, 0, 0, 0.8);
      margin-top: 20px;
      width: 100%;
      .package-info{
        h3{
          color:#ffffff;
          text-align: right;
        }
        .agancy-price{
          .price-value{
            color:red;
          }
          .count-value{
            color:#ffffff;
          }
          .agancy-name{
            color:#ffffff;
          }
        }
      }
      .image-box{
        img{
          width: 95px;
          height: 95px;
          border-radius: 50%;
        }
      }
    }
  }
}
</style>
